import request from '../../axios';

const deleteBasket = async (advertisement_id: string) => {
  await request.delete(`/api/v2/order/basket/${advertisement_id}`);
};

export default deleteBasket;
